"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FeaturesContentItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _index2 = _interopRequireDefault(require("../../../elements/other/section-item/index.js"));
var _index3 = _interopRequireWildcard(require("../../../elements/other/attributed-image/index.js"));
var _section = require("@site/pattern-library-core/section");
var _image = require("@site/pattern-library-core/image");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FeaturesContentItemContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "FeaturesContentItemContainer",
  class: "pl-f1ogno4n",
  vars: {
    "f1ogno4n-0": [({
      backgroundColor
    }) => backgroundColor || _intents.default.ux.box.backgroundColor],
    "f1ogno4n-2": [({
      inset
    }) => inset ? 'calc(var(--layout-rail-tabletLg) - var(--inset-margin-side))' : '0px'],
    "f1ogno4n-3": [({
      inset
    }) => {
      if (inset) {
        return 'var(--fixed-space-100)';
      }
      return '0px';
    }],
    "f1ogno4n-4": [({
      inset,
      backgroundColor,
      hasBgImage
    }) => {
      if (backgroundColor || hasBgImage) {
        return 'var(--fixed-space-200)';
      } else if (inset) {
        return 'var(--fixed-space-100)';
      }
      return '0px';
    }],
    "f1ogno4n-5": [({
      sectionHeight,
      backgroundColor,
      hasBgImage,
      hasAllBgImages
    }) => {
      if (!hasBgImage && !backgroundColor) {
        return 'initial';
      } else if (sectionHeight === 'tall') {
        return '60vmax';
      } else if (!backgroundColor && hasAllBgImages) {
        return '45vmax';
      }
      return 'initial';
    }],
    "f1ogno4n-6": [({
      inset,
      banner
    }) => inset || banner ? _intents.default.ux.box.borderRadius : 'initial'],
    "f1ogno4n-7": [({
      verticalPadding
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalPadding, true)],
    "f1ogno4n-10": [({
      textAlign
    }) => textAlign === 'center' ? '1fr' : 'repeat(auto-fit, minmax(0, 1fr))'],
    "f1ogno4n-11": [({
      textAlign
    }) => textAlign === 'center' ? 'flex' : 'grid'],
    "f1ogno4n-13": [({
      inset,
      banner
    }) => {
      if (inset) {
        return 'var(--fixed-space-200)';
      } else if (banner) {
        return 'var(--fixed-space-1000)';
      }
      return '0px';
    }],
    "f1ogno4n-14": [({
      inset,
      backgroundColor,
      hasBgImage
    }) => {
      if (backgroundColor || hasBgImage) {
        return 'var(--viewport-space-100)';
      } else if (inset) {
        return 'var(--fixed-space-200)';
      }
      return '0px';
    }],
    "f1ogno4n-15": [({
      verticalPadding
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalPadding)],
    "f1ogno4n-18": [({
      hasBgImage,
      hasAllBgImages,
      landscape,
      sectionHeight,
      backgroundColor
    }) => {
      if (!hasBgImage && !backgroundColor) {
        return '1rem';
      } else if (hasAllBgImages && sectionHeight !== 'tall' || landscape && sectionHeight !== 'tall' || backgroundColor && sectionHeight !== 'tall') {
        return 'var(--layout-rail-base)';
      }
      return 'var(--fixed-space-400)';
    }],
    "f1ogno4n-19": [({
      parentSectionPadding,
      inset
    }) => {
      if (parentSectionPadding === 'large' && !inset || parentSectionPadding === 'small' && !inset || !parentSectionPadding && !inset) {
        return '0px';
      }
      return 'var(--layout-rail-base)';
    }],
    "f1ogno4n-26": [({
      banner
    }) => banner ? 'var(--layout-rail-tabletLg)' : '0 var(--layout-rail-tabletLg)'],
    "f1ogno4n-30": [({
      inset
    }) => inset ? _intents.default.ux.box.borderRadius : 'none']
  }
});

/**
 * @ignore @typedef {import('csstype').Property.BackgroundImage} BackgroundImage
 */
/**
 * FeaturesContentItem component.
 * @module FeaturesContentItem
 *
 * @param {Object} props React props
 * @param {string} props._name The tracking name for the component
 * @param {String} props.id The id of the content item
 * @param {Boolean} props.inset Boolean for outer margin
 * @param {Boolean} props.banner Boolean for Banner outer margin
 * @param {Boolean} props.invert Invert Color Props
 * @param {String} props.partial Theme partial
 * @param {String} props.layout layout
 * @param {Object} props.attribution attribution
 * @param {BackgroundImage} props.landscape url
 * @param {BackgroundImage} props.portrait Image url
 * @param {BackgroundImage} props.tablet Image url
 * @param {Object} props.backgroundColor backgroundColor
 * @param {Object} props.headlineContent attribution
 * @param {String} props.margin margin
 * @param {String} props.padding padding
 * @param {Object} props.priceLockup priceLockup
 * @param {String} props.verticalPadding vertical inner spacing
 * @returns {ReactElement} Features Headline Blade layout
 * @public
 */
function FeaturesContentItem({
  _name,
  id,
  inset = false,
  banner,
  invert = false,
  partial,
  layout = 'center',
  attribution = {},
  landscape,
  portrait,
  tablet,
  backgroundColor,
  margin = 'none',
  padding,
  verticalPadding,
  parentSectionPadding,
  featureImagePlacement,
  priceLockup,
  ...rest
}) {
  const layoutStyles = () => {
    if (layout === 'center') {
      return {
        textAlign: 'center'
      };
    } else if (layout === 'center-tall') {
      return {
        textAlign: 'center',
        sectionHeight: 'tall'
      };
    } else if (layout === 'full') {
      return {
        'textAlign': 'start',
        'data-layout': layout
      };
    } else if (layout === 'full-reverse') {
      return {
        'textAlign': 'start',
        'data-layout': 'full',
        'data-direction': 'full-reverse'
      };
    } else if (layout === 'split') {
      return {
        'textAlign': 'start',
        'data-layout': layout,
        'headlineSectionAlignment': 'flex-start'
      };
    } else if (layout === 'split-reverse') {
      return {
        'textAlign': 'start',
        'data-layout': layout,
        'data-direction': 'reverse',
        'headlineSectionAlignment': 'flex-end'
      };
    }
  };
  const hasBgImage = landscape || tablet || portrait;
  const hasAllBgImages = landscape && tablet && portrait;
  const layoutProps = layoutStyles();
  const {
    textAlign,
    imageContextProps
  } = layoutProps;
  return /*#__PURE__*/_react.default.createElement(FeaturesContentItemContainer, (0, _extends2.default)({
    _name: _name,
    id: `id-${id}`,
    className: _section.sectionStyle,
    inset: inset,
    banner: banner,
    "data-partial": partial || (invert ? 'dark1' : ''),
    hasAllBgImages: hasAllBgImages,
    hasBgImage: hasBgImage,
    landscape: landscape?.url,
    portrait: portrait?.url,
    tablet: tablet?.url,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor),
    textAlign: textAlign,
    "data-margin": margin,
    "data-padding": padding,
    dataCy: "features-content-item",
    elementType: "section",
    verticalPadding: verticalPadding,
    parentSectionPadding: parentSectionPadding,
    featureImagePlacement: featureImagePlacement
  }, layoutProps), /*#__PURE__*/_react.default.createElement(_index2.default, (0, _extends2.default)({
    dataCy: "content-item",
    className: "content-item"
  }, layoutProps, rest), /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({}, rest, {
    textAlign: textAlign,
    headlineTag: rest?.headlineTag || (rest?.eyebrow ? 'h3' : 'h2'),
    priceLockup: priceLockup || rest?.priceLockup
  }))), Object.keys(attribution).length > 0 && /*#__PURE__*/_react.default.createElement(_index3.default, (0, _extends2.default)({
    key: "image",
    imageContextProps: imageContextProps
  }, attribution)));
}
FeaturesContentItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  inset: _propTypes.default.bool,
  banner: _propTypes.default.bool,
  priceLockup: _propTypes.default.object,
  landscape: _propTypes.default.shape(_image.imgPropShape),
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tablet: _propTypes.default.shape(_image.imgPropShape),
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['center', 'center-tall', 'split', 'split-reverse', 'full', 'full-reverse']),
  attribution: _propTypes.default.object,
  headlineContent: _propTypes.default.shape(_index.default.propTypes),
  margin: _propTypes.default.oneOf(['none', 'small', 'large']),
  padding: _propTypes.default.oneOf(['none', 'small', 'large']),
  parentSectionPadding: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  featureImagePlacement: _propTypes.default.oneOf(['start-left', 'start-right', 'off']),
  ..._patternLibraryUtils.paddingProps
};